<template>
	<div>
		<!-- <header-nav :bg="bg" :text="text" /> -->
		<div class="yindao_iv" v-if="device !== 'true'">
			<img class="xiantou" src="../../asset/xiantou.png" alt="">
			<div class="text">
				<div class="text_h1">若已安装研小白APP</div>
				<div class="text_p1">1. 点击右上角 <span>···</span></div>
				<div class="text_p2">2. 选择在 <span>浏览器</span> 中打开</div>
			</div>
			<img class="yindao" src="../../asset/yindao.png" alt="">
		</div>
		<div v-else>
			<div class="xia_top">
				<!-- <div> -->
				<img src="../../asset/logo.png" alt="">
				<h2>研小白</h2>
				<p>考研数字化备考服务平台</p>
				<div class="btnsD" v-if="imgD == 'ios'" @click="xiazai_ios">
					<div>
						<img src="../../asset/IOS.png" alt="">
						下载APP
					</div>
				</div>
				<div class="btnsD" v-else @click="xiazai_android">
					<div>
						<img src="../../asset/Android.png" alt="" />
						下载APP
					</div>

				</div>
				<!-- </div> -->
			</div>
			<div class="h1">获取资讯、分享生活</div>
			<div class="h3">实时获取考研资讯、分享考研生活</div>
			<div class="screenshot-wrap">
				<img class="screenshot" src="../../assets/screenshot1.png" />
				<img class="screenshot" src="../../assets/screenshot2.png" />
				<img class="screenshot" src="../../assets/screenshot3.png" />
				<img class="screenshot" src="../../assets/screenshot4.png" />
			</div>
			<div class="notes">
				<div class="h1">研小白关心每一位考研er的声音</div>
				<div class="h2">如您在研小白APP的使用过程中遇到难以解决的问题，以及任何对平台发展有益的意见及建议，欢迎您直接写信到邮箱：fb@ikaoyaner.com。</div>
				<div class="h2">为了您的来信能够得到更高效的处理，请您在邮件中标注以下信息：</div>
				<ul class="ul">
					<li>您的个人或工作单位信息（公司/品牌/部门/岗位/姓名 等）</li>
					<li>您的联系方式（邮箱地址/直线电话 等）</li>
					<li>相关问题、意见或建议的具体描述（背景/案例/各类支持性材料 等）</li>
				</ul>
			</div>
			<div class="h1">更多方式关注研小白</div>
			<div class="contact-wrap">
				<div class="contact">
					<img src="../../assets/focus-gzh.png" />
					<span>关注微信公众号</span>
				</div>
				<div class="contact">
					<img src="../../assets/focus-wb.png" />
					<span>关注微博</span>
				</div>
				<div class="contact">
					<img src="../../assets/focus-xcx.png" />
					<span>关注小程序</span>
				</div>
			</div>
			<Footer />
		</div>
	</div>
</template>

<script>
	import HeaderNav from '../../components/HeaderNav'
	import Footer from '../../components/Footer'
	import bg from '../../assets/header-bg1.png'
	export default {
		components: {
			HeaderNav,
			Footer,

		},

		data() {
			return {
				bg,
				text: '研小白 - 考研数字化备考服务平台',
				device: "",
				imgD: "",
			}
		},
		created() {
			var storage = window.sessionStorage;
			var device = storage.getItem('device');


			if (device) {
				this.device = device
			}
			var browser = {

				versions: function() {
					var u = navigator.userAgent,
						app = navigator.appVersion;
					return {
						trident: u.indexOf('Trident') > -1,
						/*IE内核*/
						presto: u.indexOf('Presto') > -1,
						/*opera内核*/
						webKit: u.indexOf('AppleWebKit') > -1,
						/*苹果、谷歌内核*/
						gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
						/*火狐内核*/
						mobile: !!u.match(/AppleWebKit.*Mobile.*/),
						/*是否为移动终端*/
						ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
						/*ios终端*/
						android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
						/*android终端或者uc浏览器*/
						iPhone: u.indexOf('iPhone') > -1,
						/*是否为iPhone或者QQHD浏览器*/
						iPad: u.indexOf('iPad') > -1,
						/*是否iPad*/
						webApp: u.indexOf('Safari') == -1,
						/*是否web应该程序，没有头部与底部*/
						souyue: u.indexOf('souyue') > -1,
						superapp: u.indexOf('superapp') > -1,
						weixin: u.toLowerCase().indexOf('micromessenger') > -1,
						Safari: u.indexOf('Safari') > -1
					};
				}(),
				language: (navigator.browserLanguage || navigator.language).toLowerCase()

			};
			if (browser.versions.ios) {
				this.imgD = "ios"
				console.log("ios")
			} else if (browser.versions.android) {

				this.imgD = "android"
				console.log("android")

				// setTimeout(function() {
				// 	alert("123")
				// 	window.location.href = "taobao://**";
				// }, 2000)
				// window.location.href='demo://test:1080/app';
				window.location.href = "taobao://**";

				setTimeout(function() {
					// 判断用户是否已经切换到了app
					if (!window.document.hidden) {
						//                            window.location.href='http://download.apk';// 下载app
					}
				}, 1000);

			}
		},
		mounted() {


		},
		methods: {
			xiazai_ios() {
				window.location.href = "https://apps.apple.com/cn/app/id1517547776"
			},
			xiazai_android() {
				window.location.href = "taobao://**";
			}
		}
	}
</script>

<style lang="less" scoped>
	@media screen and (max-width:760px) {
		.notes {
			display: none;
		}
	}
	.yindao_iv{
		text-align: center;
	}
	.yindao{
		width: 300px;
		margin:  60px auto 0;
	}
	.text{
		margin: 40px 50px 0;
		// text-align: center;
		.text_h1{
			font-size: 19px;
			font-weight: 500;
			color: #333;
		}
		>div + div{
			margin-top: 14px;
		}
		>div{
			text-align: left;
			color: #7A7A7A;
			font-weight: 400;
			font-size: 15px;
			
			>span{
				font-size: 17px;
				font-weight: bold;
				color: #333;
			}
		}
	}
	.xiantou{
		position: fixed;
		right: 15px;
		top: 18px;
		width: 171px;
		height: 75px;
		
	}
	
	.xia_top {
		// display: flex;
		// align-items: center;
		justify-content: center;
		padding-top: 100px;

		// >div{
		text-align: center;

		>p {
			color: #AAA;
			font-size: 14px;
		}

		>img {
			width: 100px;
			margin: 0 auto;
			border: 1px solid #CCC;
			border-radius: 6px;
			display: block;
		}

		// }
		.btnsD {
			width: 200px;
			height: 40px;
			border: 1px solid #CCC;
			background-color: #999;
			color: #fff;
			border-radius: 4px;
			margin-top: 10px;
			// margin-left: 50%;
			margin: 10px auto 0;

			>div {
				width: 200px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;

				>img {
					width: 16px;
					height: 16px;
					margin: 0 6px;
				}
			}


		}

	}

	.h1 {
		margin-top: 73px;
		text-align: center;
		font-size: 26px;
		color: #333333;
	}

	.h3 {
		margin-top: 14px;
		text-align: center;
		font-size: 22px;
		color: #595959;
	}

	.screenshot-wrap {
		margin-top: 48px;
		margin-bottom: 80px;
		text-align: center;

		.screenshot {
			width: 240px;
			margin-right: 20px;
			box-shadow: 0 0 20px 0 #eeeeee;
		}

		img {
			margin-top: 20px;
		}
	}

	.notes {
		// width: 100%;
		padding-bottom: 60px;
		background: #FBFBFB;
		overflow: hidden;
		padding: 0 50px;
		box-sizing: border-box;

		.h1 {
			margin-bottom: 48px;
		}

		.h2 {
			// width: 882px;
			margin: 0 auto;
			margin-bottom: 22px;
			color: #595959;
			font-size: 22px;
			line-height: 35px;
		}

		.ul {
			width: 882px;
			margin: 0 auto;
			margin-top: -16px;
			margin-bottom: 50px;
			color: #595959;
			font-size: 16px;
			line-height: 28px;

			>li {
				margin-left: 20px;
			}
		}
	}

	.contact-wrap {
		display: flex;
		justify-content: space-between;
		width: 485px;
		margin: 62px auto 127px auto;

		.contact {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			>span {
				margin-top: 6px;
				font-size: 16px;
				color: #595959;
			}
		}
	}

	@media screen and (max-width:500px) {
		.notes {
			.h2 {
				width: 350px;
			}

			.ul {
				margin-left: -28px;
				width: auto;
			}
		}

		.contact-wrap {
			width: 100%;
			padding: 0 12px;
			box-sizing: border-box;

			.contact {
				margin-right: 0;
			}
		}
	}
</style>
